"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12"
}, _react.default.createElement("path", {
  d: "M3.67 3.3C3.67 2.05 4.72 1 6 1A2.33 2.33 0 018.3 3.32c.03.67-.22 1.44-.68 2.05-.45.6-1.04.96-1.63.96-.56 0-1.13-.35-1.59-.96a3.62 3.62 0 01-.73-2.07zM6 0a3.33 3.33 0 00-3.32 3.3c0 .92.36 1.9.93 2.67C4.16 6.72 5 7.33 6 7.33c1.01 0 1.87-.6 2.43-1.36.57-.76.92-1.75.88-2.68C9.3 1.49 7.8 0 6 0zM2.63 7.02a.5.5 0 10-.64-.77C1.41 6.73.94 7.2.61 7.76A4.43 4.43 0 000 9.7c-.02.13 0 .26.04.36a1 1 0 00.33.46l.11.07.34.2A11.7 11.7 0 005.99 12c2 0 3.42-.35 4.34-.72a5.44 5.44 0 001.3-.75 1.15 1.15 0 00.14-.15 1 1 0 00.23-.67 4.65 4.65 0 00-1.9-3.45.5.5 0 00-.66.75c.57.5.92.92 1.15 1.33.22.4.34.82.4 1.4a.5.5 0 00-.03.05l-.17.13c-.16.11-.44.27-.84.43-.79.33-2.07.65-3.96.65A10.7 10.7 0 011.3 9.9a4.17 4.17 0 01-.3-.18c.07-.6.22-1.04.46-1.44.26-.42.63-.81 1.17-1.26zM.96 9.69z"
}));

exports.default = _default;